import { parseDateOnly } from './dateOnly';

export const stringParam = (defaultValue = '') => ({
  defaultValue,
  parse: (value) => value,
  serialize: (value) => (typeof value === 'string' ? value : undefined)
});

export const positiveIntegerParam = (defaultValue = 1) => ({
  defaultValue,
  parse: (value) => {
    const parsed = Number(value);
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : defaultValue;
  },
  serialize: (value) => (Number.isSafeInteger(value) && value > 0 ? String(value) : undefined)
});

export const oneOfParam = (values, defaultValue) => ({
  defaultValue,
  parse: (value) => (values.includes(value) ? value : defaultValue),
  serialize: (value) => (values.includes(value) ? value : undefined)
});

export const dateOnlyParam = (defaultValue = '') => ({
  defaultValue,
  parse: (value) => (parseDateOnly(value) ? value : defaultValue),
  serialize: (value) => (parseDateOnly(value) ? value : undefined)
});
